export function getLessonDurationInAcademicHours(seconds: number): number {
  return Number((seconds / 60 / 45).toFixed(2));
}
